import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { AvtalePage } from './avtaler.page';
import { routes } from './avtaler.routes';
import { AvtaleKortComponent } from './avtale-kort/avtale-kort.component';
import { ComponentsModule } from '../../shared/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AvtaleKortComponent,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentsModule
  ],
  declarations: [AvtalePage]
})
export class AvtalePageModule {}
